import { useSelector } from "react-redux";
import { getAvailableDevices } from "../../../reducers/devices";
import { Menu } from "@mui/material";
import DeviceItem from "./DeviceItem";

const DeviceList = ({open, anchor, closeHandler}) => {
    const availableDevices = useSelector(getAvailableDevices);

    return (
        <Menu
            open={open}
            onClose={closeHandler}
            anchorEl={anchor}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
        >
            <div className="d-flex flex-column gap-0_5">
            {
                availableDevices &&
                availableDevices.map((device, index) => <DeviceItem key={index} device={device} onClickDevice={closeHandler}/>)
            }
            </div>
        </Menu>
    );
};

export default DeviceList;